import { useParams } from "react-router-dom";
import { SmsCampaignScheduleForm } from "../../../../../components/secondaryComponents/SmsCampaign";
import { useGetSmsCampaignDetails } from "../../../../../hooks/api/queries/useMarketing";
import secondaryComponents from "../../../../../components/secondaryComponents";

const SmsCampaignSchedule = () => {
  const { id } = useParams();
  const { data: smsCampaign, isLoading } = useGetSmsCampaignDetails({ id });
  return (
    <section style={{ maxWidth: "900px" }}>
      <secondaryComponents.LoaderHelper
        classNames={"mt-5"}
        isLoading={isLoading}
      >
        <SmsCampaignScheduleForm smsCampaign={smsCampaign} />
      </secondaryComponents.LoaderHelper>
    </section>
  );
};

export default SmsCampaignSchedule;
